<lib-filters-component [filters_options]="filter_service.filtersType">

</lib-filters-component>
